import store from "@/store";
import { OpportunityAttachmentData } from "@/models/OpportunityAttachmentData";
import { BaseChildDocumentStore } from "./BaseChildDocumentStore";
import { OpportunityData } from "@/models/OpportunityData";
import { OpportunityAttachmentService } from "@/services/OpportunityAttachmentService";
import { globalStore } from "./GlobalStore";
import { NullableString } from "@/code/Types";

class OpportunityAttachementStore extends BaseChildDocumentStore<
  OpportunityAttachmentData,
  OpportunityData,
  OpportunityAttachmentService
> {
  parent: OpportunityData = new OpportunityData();
  current: OpportunityAttachmentData = new OpportunityAttachmentData();

  newEntity(): OpportunityAttachmentData {
    return new OpportunityAttachmentData();
  }

  get service(): OpportunityAttachmentService {
    return new OpportunityAttachmentService();
  }

  async downloadFile(id: NullableString, filename: string): Promise<File> {
    try {
      globalStore.setIsBusy(true);
      return await this.service.downloadFile(id, filename);
    } finally {
      globalStore.setIsBusy(false);
    }
  }
}

export const opportunitiyAttachmentStore = new OpportunityAttachementStore({
  store,
  name: "opportunitiyAttachmentStore",
});
